export default function userLoginReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'LOGIN_USER_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'LOGIN_USER_ERROR':
            return {...state, ...{error: action.error}};

        case 'LOGIN_USER_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}